/**
 * Route constants — single source of truth for all app routes.
 * Mirrors racore-app/constants/Routes.ts adapted for TanStack Router paths.
 */

export const AUTH_ROUTE = '/auth/login' as const;

export const HOME_ROUTE = '/home' as const;
export const MY_RECO_ROUTE = '/my-reco' as const;
export const RECOMMENDATION_ROUTE = '/recommendation' as const;
export const PROFILE_ROUTE = '/profile' as const;
export const RECO_SHARE_ROUTE = '/reco-share' as const;
export const COLLECTION_ROUTE = '/collection' as const;

/** Auth callback — receives OAuth code from Spotify / Google / Deezer */
export const AUTH_CALLBACK_ROUTE = '/auth/callback' as const;

export type AppRoute =
  | typeof AUTH_ROUTE
  | typeof HOME_ROUTE
  | typeof MY_RECO_ROUTE
  | typeof RECOMMENDATION_ROUTE
  | typeof PROFILE_ROUTE
  | typeof RECO_SHARE_ROUTE
  | typeof COLLECTION_ROUTE
  | typeof AUTH_CALLBACK_ROUTE;
